import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { LazyLoadImage, trackWindowScroll } from 'react-lazy-load-image-component';

import { MetaMaskContext } from '../metamask';
import ConnectButton from '../metamask/button';
import shuffle from '../shuffle';


import './style.scss';


const SodabitGridItem = ({id, onClick, scrollPosition}) => {
  let image = `/sodabits/${id}.png`;
  let name = `Sodabit ${id}`;

  return(
    <span className="pfp-sodabit" onClick={() => onClick(id)} key={id}>
      <LazyLoadImage
        alt={name}
        scrollPosition={scrollPosition}
        src={image}
      />
    </span>
  );
};

const RandomSodabitGrid = trackWindowScroll(({ scrollPosition, onClick }) => {
  const [ids, setIds] = useState(() => {
    const all = [];
    for(let i=1; i <= 1000; i++) {
      all.push(i);
    }
    return shuffle(all);
  });


  return (<div className="random-sodabit-grid">
    {
      ids.map((id) => {
        return <SodabitGridItem {...{id, onClick, scrollPosition}} key={id} />
      })
    }
    </div>);
});

const useOwnSodabits = () => {
  const [ ids, setIds ] = useState([]);
  const { accounts, connect } = useContext(MetaMaskContext);

  const account = accounts[0] || '';


  useEffect(() => {
    const own = Object.entries(window.SodabitsOwners)
      .filter(([id, owner]) => owner.toLowerCase() === account)
      .map(([id, owner]) => id);
    setIds(shuffle(own));
  }, [account]);

  return ids;
};

const OwnSodabitsGrid = trackWindowScroll(({ scrollPosition, onClick }) => {
  const ids = useOwnSodabits();

  return (<>
    {
      ids.map((id) => {
        return <SodabitGridItem {...{id, onClick, scrollPosition}} key={id} />
      })
    }
    </>);
});


export {
  OwnSodabitsGrid,
  RandomSodabitGrid,
  SodabitGridItem,
  useOwnSodabits,
};
